import {
	type AnalyticsAttributes,
	fireTrackAnalytics,
	type AnalyticsEvent,
} from '@atlassian/jira-product-analytics-bridge';

import { supportedViews } from '@atlassian/jira-ui-modifications-fields-configuration/src/common/utils/views';
import type { ViewType } from '@atlassian/jira-ui-modifications-types';

/**
 * @deprecated use `fireTrackAnalytics` from `@atlassian/jira-ui-modifications-analytics` package
 */
export const fireIATrackAnalytics = (
	event: AnalyticsEvent,
	id: string,
	viewType: ViewType,
	attributes: AnalyticsAttributes = {},
) => {
	const prefix = supportedViews[viewType] ? viewType : '';

	fireTrackAnalytics(event, `${prefix}${id}`, attributes);
};
